function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useContext, useMemo } from 'react';
import ConfirmationDialog from '../ConfirmationDialog';
export let DialogLabelSet = /*#__PURE__*/function (DialogLabelSet) {
  DialogLabelSet["CONFIRM"] = "CONFIRM";
  DialogLabelSet["ALERT"] = "ALERT";
  return DialogLabelSet;
}({});
// These should be provided to the provider as registerdialogTypeActions
export const standardDialogLabelSetActions = {
  [DialogLabelSet.ALERT]: {
    resolveActions: [{
      label: 'OK',
      reason: 'ok'
    }],
    rejectActions: null
  },
  [DialogLabelSet.CONFIRM]: {
    resolveActions: [{
      label: 'Confirm',
      reason: 'ok'
    }],
    rejectActions: [{
      label: 'Cancel',
      reason: 'cancel'
    }]
  }
};
const ConfirmationDialogServiceContext = /*#__PURE__*/React.createContext(null);
export const useConfirmation = () => useContext(ConfirmationDialogServiceContext);
export const ConfirmationDialogServiceProvider = props => {
  const {
    registerDialogLabelSetActions,
    children
  } = props;
  const dialogLabelSetActions = useMemo(() => ({
    ...standardDialogLabelSetActions,
    ...registerDialogLabelSetActions
  }), [registerDialogLabelSetActions]);
  const [open, setOpen] = useState(false);
  const [confirmationProps, setConfirmationProps] = useState(null);
  const [dialogLabelSet, setDialogLabelSet] = useState(DialogLabelSet.CONFIRM);
  const [dialogLabelSetAction, setDialogLabelSetActions] = useState(null);

  // useEffect(() => {
  //   setDialogLabelSetActions(dialogLabelSetActions[dialogLabelSet]);
  // }, [dialogLabelSet]);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const confirmContext = {
    open: openConfirmationProps => {
      const {
        dialogLabelSet: openDialogLabelSet,
        dialogLabelSetActions: openDialogLabelSetActions,
        ...restOpenConfirmationProps
      } = openConfirmationProps;
      const labelSet = openDialogLabelSet;
      const labelActions = openDialogLabelSetActions || dialogLabelSetActions[labelSet];
      setOpen(true);
      setDialogLabelSetActions(labelActions);
      setConfirmationProps(restOpenConfirmationProps);
    },
    getDialogLabelSetActions: dialogLabelSet => {
      return dialogLabelSetActions[dialogLabelSet];
    }
  };
  const buildConfirmProps = {
    title: 'UNDEFINED',
    onReject: () => {},
    onResolve: () => {},
    maxWidth: 500,
    // default if not passed
    ...dialogLabelSetAction,
    ...confirmationProps
  };
  const {
    onExited,
    onClose,
    ...confirmProps
  } = buildConfirmProps;
  const handleClose = e => {
    setOpen(false);
    if (typeof onClose === 'function') {
      onClose(e);
    }
  };
  const handleExited = e => {
    setConfirmationProps(null);
    if (typeof onExited === 'function') {
      onExited(e);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfirmationDialogServiceContext.Provider, {
    value: confirmContext
  }, children), /*#__PURE__*/React.createElement(ConfirmationDialog, _extends({}, confirmProps, {
    open: open,
    onClose: handleClose,
    onExited: handleExited
  })));
};